import Flex from 'legacyfrontend/components/Flex';
import LoadSpinner from 'legacyfrontend/components/spinner';
import { useMemo, useState } from 'react';
import FlightInfoItem from './FlightInfoItem';

const PackageDetailFlightsInfo = ({ configuration }) => {
  const [totalMoves, setTotalMoves] = useState(undefined);
  let move = 0;

  const items = useMemo(
    () =>
      !configuration?.flight
        ? undefined
        : configuration.flight.tripInformation
            .sort(({ order: a }, { order: b }) => a - b)
            .map((item, index) => {
              const thisMove = move;
              let nextDepartureDate;
              if (configuration.flight.tripInformation[index + 1]) {
                const diferenciaMs =
                  index + 1 === configuration.flight.tripInformation.length
                    ? 0
                    : new Date(configuration.flight.tripInformation[index + 1].departureDate) -
                      new Date(item.arrivalDate);
                const timeDiff = Math.floor(diferenciaMs / (1000 * 60 * 60));

                nextDepartureDate =
                  timeDiff > 24
                    ? undefined
                    : configuration.flight.tripInformation[index + 1].departureDate;
              }
              if (!nextDepartureDate) {
                move++;
              }
              if (index + 1 === configuration.flight.tripInformation.length) {
                setTotalMoves(thisMove);
              }
              return {
                ...item,
                thisMove,
                nextDepartureDate,
              };
            }),
    [configuration]
  );

  return !items ? (
    <LoadSpinner style={{ marginTop: 20, marginBottom: 20 }} />
  ) : (
    <Flex className='package-details__dynamic-content__wrapper__flight-list__records' vertical>
      {items.map((item) => {
        return (
          <FlightInfoItem
            key={item.id}
            {...item}
            flightCompany={
              configuration.flight.juliaToursCompany?.nombreCompaniaAerea
                ? configuration.flight.juliaToursCompany.nombreCompaniaAerea
                : undefined
            }
            totalMoves={totalMoves}
          />
        );
      })}
    </Flex>
  );
};

export default PackageDetailFlightsInfo;
